import Terms from '@/features/termAndPrivacy/pages/Terms'

export default Terms
